export default __webpack_public_path__ + "static/media/ActiveChipCloseIcon.f1102671.svg";